<template>
    <div>

        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                        <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="editExemplar && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitExemplar" v-if="!editExemplar || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editExemplar || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Livro" prop="livro_id" :rules="[$requiredBlur]" key="livro_id">
                            <el-select
                                v-model="dados.livro_id"
                                placeholder="Pesquisar livro..."
                                filterable
                                remote
                                :remote-method="getLivroByFilter"
                                :loading="loadingLivro"
                                style="width: 100%;">
                                <el-option
                                    v-for="item in livros"
                                    :key="item.id"
                                    :label="formatLivroLabel(item)"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Código do exemplar (opcional)" prop="codigo" key="codigo">
                            <el-input v-model="dados.codigo" maxlength="191" v-on:blur="formatData('codigo')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
                            <el-select v-model="dados.status">
                                <el-option label="DISPONÍVEL" value="disponivel"></el-option>
                                <el-option label="EMPRESTADO" value="emprestado"></el-option>
                                <el-option label="RESERVADO" value="reservado"></el-option>
                                <el-option label="DANIFICADO" value="danificado"></el-option>
                                <el-option label="PERDIDO" value="perdido"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Localização" prop="localizacao" key="localizacao">
                            <el-input v-model="dados.localizacao" maxlength="191" v-on:blur="formatData('localizacao')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Estado de conservação" prop="estado_conservacao" key="estado_conservacao">
                            <el-select v-model="dados.estado_conservacao" clearable placeholder="Selecione" style="width: 100%;">
                                <el-option label="NOVO" value="NOVO"></el-option>
                                <el-option label="ÓTIMO" value="OTIMO"></el-option>
                                <el-option label="BOM" value="BOM"></el-option>
                                <el-option label="REGULAR" value="REGULAR"></el-option>
                                <el-option label="RUIM" value="RUIM"></el-option>
                                <el-option label="DANIFICADO" value="DANIFICADO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-exemplar" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>

<script>
export default {
    props: ['paramId'],
    data: () => ({
        editExemplar: false,
        loadingLivro: false,
        livros: [],
        filtroInstituicao: { id: '', nome: '' },
        dados: {
            id: '',
            codigo: '',
            livro_id: '',
            status: 'disponivel',
            localizacao: '',
            estado_conservacao: ''
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        this.restaurarInstituicaoDoQuery();
        if(this.$store.state.config.instituicao){
            this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods:{
        restaurarInstituicaoDoQuery(){
            const qId = this.$route.query.instituicao_id;
            if(!qId) return;
            const atual = this.$store.state.config.instituicao;
            if(atual && atual.id && String(atual.id) === String(qId)) return;
            const lista = this.$store.state.instituicoes || [];
            const fromList = Array.isArray(lista)
                ? lista.find(x => x && String(x.id) === String(qId))
                : (lista[qId] || null);
            const inst = fromList || { id: qId, nome: '' };
            this.$store.commit('setInstituicao', inst);
        },
        formatLivroLabel(item){
            const titulo = item && item.titulo ? item.titulo : '';
            const autor = item && item.autor ? item.autor : '';
            const isbn = item && item.isbn ? item.isbn : '';

            let label = `#${item.id}`;
            if(titulo) label += ` - ${titulo}`;
            if(autor) label += ` (${autor})`;
            if(isbn) label += ` - ISBN: ${isbn}`;
            return label;
        },
        getLivroByFilter(query){
            if(!query || query.length < 2){
                this.livros = [];
                return;
            }

            this.loadingLivro = true;
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/livro/searchByNome`, { query, instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth).then(response => {
                const data = response.data || [];
                this.livros = Array.isArray(data) ? data : [];
                this.loadingLivro = false;
            }).catch((error) => {
                this.loadingLivro = false;
                this.$store.commit('throwException', error);
            });
        },
        getExemplarById(id){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
                this.dados = JSON.parse(JSON.stringify(response.data));
                if(this.dados && this.dados.livro){
                    this.livros = [this.dados.livro];
                }
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitExemplar(){
            document.getElementById("btn-exemplar").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
                window.eventBus.$emit('loading', true);

                const trataErro = (response) => {
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível salvar o exemplar.');
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return true;
                    }
                    return false;
                };

                const emit = () => {
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('onSubmitExemplar');
                };

                if(this.editExemplar){
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        emit();
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }else{
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/store`, this.dados, this.$store.getters.getHeaderAuth).then((response) => {
                        if(trataErro(response)) return;
                        emit();
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }
            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field){
            if(!this.dados[field]) return false;
            this.dados[field] = this.dados[field].toUpperCase();
            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if(value){
                    this.getExemplarById(value);
                    this.editExemplar = true;
                }
            }
        }
    }
}
</script>

